export const SCAN_STEPS = [
  'Google Business Profile',
  'GBP Deep Dive',
  'Google Review Sentiment',
  'Photo Quality & Quantity',
  'Website Audit',
  'Mobile Experience',
  'Competitor Benchmarking'
];

export const SCAN_ACTIVITY_LABELS = [
  'Auditing profile completeness and listing health',
  'Running deep GBP quality and market-position diagnostics',
  'Analyzing review language sentiment and complaint themes',
  'Evaluating photo inventory depth and visual coverage',
  'Running technical website quality checks',
  'Assessing mobile readiness and conversion friction',
  'Benchmarking competitor gaps and rank deltas'
];

export const SCAN_STEP_MIN_DURATION_MS = [
  1800,
  3800,
  2000,
  1900,
  2100,
  1900,
  2000
];